<app-sidebar></app-sidebar>
<main class="dashboard-main">
  <div class="dashboard-content">
    <div class="dashboard-header" style="display:flex; align-items:center; justify-content:space-between;">
      <div>
        <h1 class="dashboard-title">Transactions</h1>
        <div class="dashboard-welcome">Monitor all payment transactions</div>
      </div>
      <button class="export-btn"
        style="height:40px; padding:0 20px; background:#10b981; color:#fff; border:none; border-radius:4px; cursor:pointer;"
        (click)="exportToCSV()">
        Export CSV
      </button>
    </div>
    <hr>

    <!-- Transaction Summary Cards -->
    <div class="transaction-summary-cards">
      <div class="summary-card">
        <div class="summary-value">{{getTotalTransactions()}}</div>
        <div class="summary-title">Total Transactions</div>
      </div>
      <div class="summary-card">
        <div class="summary-value success">{{getSuccessTransactions()}}</div>
        <div class="summary-title">Successful</div>
      </div>
      <div class="summary-card">
        <div class="summary-value pending">{{getPendingTransactions()}}</div>
        <div class="summary-title">Pending</div>
      </div>
      <div class="summary-card">
        <div class="summary-value">₹{{getTotalAmount() | number}}</div>
        <div class="summary-title">Total Amount</div>
      </div>
    </div>

    <div class="my-6 flex flex-col lg:flex-row gap-3 flex-wrap items-start lg:items-center">
      <input type="text" placeholder="Search transactions..." [(ngModel)]="searchTerm" #searchBox
        (input)="onSearch(searchBox.value)"
        class="flex-1 min-w-[200px] md:w-80 px-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:border-blue-500" />
      <select [(ngModel)]="statusFilter" (change)="onStatusFilterChange()"
        class="px-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:border-blue-500">
        <option value="">All Status</option>
        <option value="success">Success</option>
        <option value="pending">Pending</option>
        <option value="failed">Failed</option>
      </select>
      <div class="flex flex-col sm:flex-row gap-2 items-start sm:items-center flex-wrap">
        <label class="text-xs text-gray-600 whitespace-nowrap">From:</label>
        <input type="date" [(ngModel)]="startDateFilter" (change)="onDateFilterChange()"
          class="px-2 py-1 border border-gray-300 rounded-md text-sm focus:outline-none focus:border-blue-500" />
        <label class="text-xs text-gray-600 whitespace-nowrap">To:</label>
        <input type="date" [(ngModel)]="endDateFilter" (change)="onDateFilterChange()"
          class="px-2 py-1 border border-gray-300 rounded-md text-sm focus:outline-none focus:border-blue-500" />
      </div>
      <button (click)="clearFilters()"
        class="px-3 py-2 border border-gray-300 rounded-md bg-white cursor-pointer text-gray-600 text-sm hover:bg-gray-50 transition-colors">
        <i class="fas fa-times-circle" style="margin-right:6px;"></i> Clear
      </button>
    </div>

    <div class="overflow-x-auto md:overflow-x-visible rounded-lg">
    <table class="modern-table min-w-full">
      <thead>
        <tr>
          <th>Transaction ID</th>
          <th>Type</th>
          <th>Invoice No</th>
          <th>Retailer</th>
          <th>Amount</th>
          <th>Method</th>
          <th>Status</th>
          <th>Date</th>
          <th>Action</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let txn of transactions">
          <td>{{txn.gateway_payment_id || 'N/A'}}</td>
          <td>
            <span [class]="getTypeClass(txn.type)"
              style="padding:4px 12px; border-radius:12px; font-size:0.85rem; font-weight:500;">
              {{txn.type | titlecase}}
            </span>
          </td>
          <td>{{txn.invoice_no || 'N/A'}}</td>
          <td>{{txn.retailer_name}}</td>
          <td>₹{{txn.amount | number}}</td>
          <td>{{txn.payment_method}}</td>
          <td>
            <span [class]="getStatusClass(txn.status)"
              style="padding:4px 12px; border-radius:12px; font-size:0.85rem; font-weight:500;">
              {{txn.status | titlecase}}
            </span>
          </td>
          <td>{{txn.transaction_date | date:'short'}}</td>
          <td>
            <span class="action-btn" (click)="viewTransaction(txn)" title="View">
              <i class="fas fa-eye"></i>
            </span>
          </td>
        </tr>
        <tr *ngIf="!loading && transactions.length === 0">
          <td colspan="8" style="text-align:center; padding:24px; color:#888;">No transactions found</td>
        </tr>
        <tr *ngIf="loading">
          <td colspan="8" style="text-align:center; padding:24px; color:#888;">Loading...</td>
        </tr>
      </tbody>
    </table>
    </div>
    <div *ngIf="pagination.totalPages > 1" class="mt-6 flex flex-col sm:flex-row justify-center items-center gap-3 flex-wrap">
      <button (click)="goToPage(pagination.page - 1)" [disabled]="!pagination.hasPrev"
        class="px-3 sm:px-4 py-2 border border-gray-300 rounded-md text-sm hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors">Prev</button>
      <span class="text-sm text-gray-600">Page {{pagination.page}} of {{pagination.totalPages}}</span>
      <button (click)="goToPage(pagination.page + 1)" [disabled]="!pagination.hasNext"
        class="px-3 sm:px-4 py-2 border border-gray-300 rounded-md text-sm hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors">Next</button>
    </div>
    <app-view-transaction-modal *ngIf="showViewModal && selectedTransaction" [transaction]="selectedTransaction"
      (close)="closeViewModal()">
    </app-view-transaction-modal>
  </div>
</main>